class FlaskaWithdrawal {
  constructor(root) {
    this.root = root;
    this.apiBase = (root.dataset.apiBase || "").replace(/\/+$/, "");
    this.state = {
      name: "",
      email: "",
      sessionToken: "",
      order: null,
      selectedItems: [],
    };

    this.progressItems = [...root.querySelectorAll("[data-progress-step]")];
    this.panels = [...root.querySelectorAll("[data-withdrawal-step]")];
    this.lookupForm = root.querySelector("[data-lookup-form]");
    this.itemsContainer = root.querySelector("[data-order-items]");
    this.summaryContainer = root.querySelector("[data-withdrawal-summary]");
    this.confirmationContainer = root.querySelector("[data-withdrawal-confirmation]");
    this.liveRegion = root.querySelector("[data-withdrawal-live]");

    this.bindEvents();
  }

  bindEvents() {
    this.lookupForm?.addEventListener("submit", (event) => {
      event.preventDefault();
      this.lookupOrder();
    });

    this.root.querySelector("[data-to-summary]")?.addEventListener("click", () => {
      this.prepareSummary();
    });
    this.root.querySelector("[data-confirm-withdrawal]")?.addEventListener("click", () => {
      this.confirmWithdrawal();
    });

    this.root.querySelectorAll("[data-back-step]").forEach((button) => {
      button.addEventListener("click", () => {
        this.showStep(Number(button.dataset.backStep));
      });
    });
  }

  async lookupOrder() {
    if (!this.lookupForm?.reportValidity()) return;
    if (!this.apiBase) {
      this.showError(
        1,
        "El servicio todavía no está configurado. Escríbenos a agua@flaska.es.",
      );
      return;
    }

    const formData = new FormData(this.lookupForm);
    const payload = {
      name: String(formData.get("name") || "").trim(),
      orderReference: String(formData.get("order_reference") || "").trim(),
      email: String(formData.get("email") || "").trim(),
    };

    this.setBusy(1, true);
    this.clearError(1);

    try {
      const result = await this.post("/v1/orders/lookup", payload);
      this.state.name = payload.name;
      this.state.email = payload.email;
      this.state.sessionToken = result.sessionToken;
      this.state.order = result.order;
      this.renderItems(result.order.items);
      this.showStep(2);
      this.announce("Pedido verificado. Selecciona los artículos.");
    } catch (error) {
      this.showError(1, error.message);
    } finally {
      this.setBusy(1, false);
    }
  }

  renderItems(items) {
    this.itemsContainer.replaceChildren();

    items.forEach((item, index) => {
      const wrapper = document.createElement("div");
      wrapper.className = "fl-withdrawal__item";

      const checkbox = document.createElement("input");
      checkbox.type = "checkbox";
      checkbox.className = "fl-withdrawal__item-checkbox";
      checkbox.id = `withdrawal-item-${index}`;
      checkbox.checked = true;
      checkbox.dataset.itemId = item.id;

      const image = document.createElement("img");
      image.className = "fl-withdrawal__item-image";
      image.width = 72;
      image.height = 72;
      image.loading = "lazy";
      image.alt = item.imageAlt || "";
      if (item.image) image.src = item.image;

      const details = document.createElement("div");
      const title = document.createElement("label");
      title.className = "fl-withdrawal__item-title";
      title.htmlFor = checkbox.id;
      title.textContent = item.title;
      details.append(title);

      if (item.sku) {
        const sku = document.createElement("span");
        sku.className = "fl-withdrawal__item-sku";
        sku.textContent = `SKU: ${item.sku}`;
        details.append(sku);
      }

      const quantityWrap = document.createElement("div");
      quantityWrap.className = "fl-withdrawal__item-quantity";
      const quantityLabel = document.createElement("label");
      const quantityId = `withdrawal-quantity-${index}`;
      quantityLabel.htmlFor = quantityId;
      quantityLabel.textContent = "Cantidad";
      const quantity = document.createElement("select");
      quantity.id = quantityId;
      quantity.dataset.quantityFor = item.id;
      quantity.dataset.maxQuantity = String(item.maxQuantity);

      for (let value = 1; value <= item.maxQuantity; value += 1) {
        const option = document.createElement("option");
        option.value = String(value);
        option.textContent = String(value);
        quantity.append(option);
      }

      quantityWrap.append(quantityLabel, quantity);
      wrapper.append(checkbox, image, details, quantityWrap);
      this.itemsContainer.append(wrapper);
    });
  }

  prepareSummary() {
    const selectedItems = this.collectSelectedItems();
    if (!selectedItems.length) {
      this.showError(2, "Selecciona al menos un artículo.");
      return;
    }

    this.clearError(2);
    this.state.selectedItems = selectedItems;
    this.renderSummary();
    this.showStep(3);
    this.announce("Revisa el resumen antes de confirmar el desistimiento.");
  }

  collectSelectedItems() {
    const selected = [];
    this.itemsContainer
      .querySelectorAll("[data-item-id]:checked")
      .forEach((checkbox) => {
        const id = checkbox.dataset.itemId;
        const quantity = this.itemsContainer.querySelector(
          `[data-quantity-for="${CSS.escape(id)}"]`,
        );
        const item = this.state.order.items.find((candidate) => candidate.id === id);
        if (item && quantity) {
          selected.push({
            id,
            title: item.title,
            sku: item.sku,
            quantity: Number(quantity.value),
          });
        }
      });
    return selected;
  }

  renderSummary() {
    this.summaryContainer.replaceChildren();

    const details = document.createElement("dl");
    this.addSummaryPair(details, "Consumidor/a", this.state.name);
    this.addSummaryPair(details, "Pedido", this.state.order.reference);
    this.addSummaryPair(details, "Confirmación", this.state.email);

    const heading = document.createElement("h3");
    heading.className = "h5";
    heading.textContent = "Artículos seleccionados";
    const list = document.createElement("ul");
    this.state.selectedItems.forEach((item) => {
      const row = document.createElement("li");
      row.textContent = `${item.quantity} × ${item.title}`;
      list.append(row);
    });

    this.summaryContainer.append(details, heading, list);
  }

  addSummaryPair(list, term, description) {
    const dt = document.createElement("dt");
    dt.textContent = term;
    const dd = document.createElement("dd");
    dd.textContent = description;
    list.append(dt, dd);
  }

  async confirmWithdrawal() {
    this.setBusy(3, true);
    this.clearError(3);

    try {
      const result = await this.post("/v1/withdrawals", {
        sessionToken: this.state.sessionToken,
        items: this.state.selectedItems.map(({ id, quantity }) => ({
          id,
          quantity,
        })),
      });

      this.renderConfirmation(result);
      this.showStep(4);
      this.downloadReceipt(result.receiptText, result.withdrawalId);
      this.announce("Desistimiento confirmado. Guarda el justificante.");
    } catch (error) {
      this.showError(3, error.message);
    } finally {
      this.setBusy(3, false);
    }
  }

  renderConfirmation(result) {
    this.confirmationContainer.replaceChildren();

    const status = document.createElement("p");
    status.className = "fl-withdrawal__status";
    status.setAttribute("role", "status");
    status.textContent = result.message;

    const receipt = document.createElement("div");
    receipt.className = "fl-withdrawal__receipt";
    const reference = document.createElement("p");
    const strong = document.createElement("strong");
    strong.textContent = "Referencia: ";
    reference.append(strong, result.withdrawalId);

    const preview = document.createElement("pre");
    preview.textContent = result.receiptText;

    const download = document.createElement("a");
    download.className = "m-button m-button--primary fl-withdrawal__receipt-link";
    download.href = result.receiptDownloadUrl;
    download.rel = "nofollow noopener";
    download.textContent = "Descargar justificante";

    receipt.append(reference, preview, download);
    this.confirmationContainer.append(status, receipt);
  }

  downloadReceipt(text, id) {
    const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `acuse-desistimiento-${id}.txt`;
    link.hidden = true;
    document.body.append(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  }

  async post(path, payload) {
    const response = await fetch(`${this.apiBase}${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const result = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(
        result.message ||
          "No se ha podido completar la operación. Inténtalo de nuevo.",
      );
    }
    return result;
  }

  showStep(step) {
    this.panels.forEach((panel) => {
      const panelStep = Number(panel.dataset.withdrawalStep);
      panel.hidden = panelStep !== step;
    });

    this.progressItems.forEach((item) => {
      const itemStep = Number(item.dataset.progressStep);
      if (itemStep === Math.min(step, 3)) {
        item.setAttribute("aria-current", "step");
      } else {
        item.removeAttribute("aria-current");
      }
      item.dataset.complete = String(itemStep < step);
    });

    const heading = this.root.querySelector(
      `[data-withdrawal-step="${step}"] h2`,
    );
    heading?.focus({ preventScroll: true });
    heading?.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  setBusy(step, busy) {
    const panel = this.root.querySelector(`[data-withdrawal-step="${step}"]`);
    const button = panel?.querySelector('[type="submit"], [data-confirm-withdrawal]');
    if (button) {
      button.disabled = busy;
      button.setAttribute("aria-busy", String(busy));
    }
  }

  showError(step, message) {
    const error = this.root.querySelector(`[data-error-step="${step}"]`);
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
    error.focus({ preventScroll: true });
    this.announce(message);
  }

  clearError(step) {
    const error = this.root.querySelector(`[data-error-step="${step}"]`);
    if (!error) return;
    error.textContent = "";
    error.hidden = true;
  }

  announce(message) {
    if (!this.liveRegion) return;
    this.liveRegion.textContent = "";
    window.setTimeout(() => {
      this.liveRegion.textContent = message;
    }, 10);
  }
}

document.querySelectorAll("[data-withdrawal-root]").forEach((root) => {
  new FlaskaWithdrawal(root);
});
